import './App.css';
import React, { useEffect, useState } from 'react';
import MainPage from './pages/mainPage/MainPage';
import TabBar from './components/tabBar/TabBar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TaskManagement from './pages/taskManagement/TaskManagement';
import InternalOrders from './pages/internalOrders/internalOrdersTab/InternalOrders';
import OpenInternalOrders from './pages/openInternalOrders/OpenInternalOrders';
import SystemRelease from './pages/systemRelease/SystemRelease';
import ConfigurationTabs from './pages/configuration/configurationTabs/ConfigurationTabs';
import TFHourRelease from './pages/tfHoursManagement/TFHourRelease';
import { ProjectProvider } from './context/ProjectContext';
import { BadgeProvider } from './context/BadgeContext';
import { DirtyProvider } from './context/DirtyContext';
import {bootstrapAuthFromURL, migrateSessionToLocalOnce} from './security/tokenStorage';
import { installAxiosAuth } from './security/axiosAuth';
import AiChatbot from './pages/aiChatbot/AiChatbot';
import SystemPlanPdfCheck from './pages/systemPlanPdfCheck/SystemPlanPdfCheck';
import StartbildNetzplan from './components/splashScreen/StartbildNetzplan.tsx';
import StartbildVorschauPage from './pages/startbildVorschau/StartbildVorschauPage.tsx';
import { isSplashReady, subscribeSplashReady } from './utils/splashReady';

bootstrapAuthFromURL();
migrateSessionToLocalOnce();
installAxiosAuth({
    apiKey: 'VdjCKidks7qTEyuU6QeJtezZ3PeCHhZQ2yHJ3kPtcfTN8BjVqU',
});

// Startbild «Netzplan» (24.09.2026). Die Anwendung laeuft von Anfang an DARUNTER: Projektliste
// und Dashboard laden waehrend des Startbilds. Weg ist es, sobald BEIDES gilt: der Ablauf ist
// einmal durch (MIN) und die Seite darunter hat gemeldet, dass sie steht (utils/splashReady).
// Anleitung: ~/Desktop/Muessig-Startbilder/STARTBILD-ANLEITUNG.md
const STARTBILD_MIN_MS = 3400;          // bis die Kette voll und die Szene fertig ist
const STARTBILD_MAX_MS = 15000;         // Reissleine, falls kein Signal kommt
const STARTBILD_AUSBLENDEN_MS = 450;    // = transition von .np-root in StartbildNetzplan.css

function App() {
    const path = window.location.pathname;
    const istVorschau = path.endsWith('/startbild-vorschau');
    // Worauf gewartet wird: die Startseite auf ihr Dashboard, jede andere Route auf die
    // Projektliste. Sonst wartet ein Tiefenlink bis zur Obergrenze auf ein Signal, das dort
    // niemand sendet.
    const wartetAuf = (path === '/' || path === '') ? 'uebersicht' : 'projekte';

    const [startbild, setStartbild] = useState(istVorschau ? 'weg' : 'zeigen');

    useEffect(() => {
        if (istVorschau) return undefined;
        let minVorbei = false;
        let wegTimer;
        const ausblenden = () => {
            setStartbild('ausblenden');
            wegTimer = setTimeout(() => setStartbild('weg'), STARTBILD_AUSBLENDEN_MS);
        };
        // `isSplashReady` statt eines Merkers: das Signal kann schon VOR dem Abonnieren
        // gekommen sein, weil Kind-Effekte vor dem Effekt der Wurzel laufen.
        const pruefen = () => {
            // Ein Fehler hebt die Mindestdauer auf - sonst verdeckt das Startbild die Meldung.
            if (isSplashReady('fehler')) { ausblenden(); return; }
            if (minVorbei && isSplashReady(wartetAuf)) ausblenden();
        };
        const minTimer = setTimeout(() => { minVorbei = true; pruefen(); }, STARTBILD_MIN_MS);
        const maxTimer = setTimeout(ausblenden, STARTBILD_MAX_MS);
        const abmelden = subscribeSplashReady(pruefen);
        pruefen();
        return () => {
            clearTimeout(minTimer);
            clearTimeout(maxTimer);
            clearTimeout(wegTimer);
            abmelden();
        };
    }, [istVorschau, wartetAuf]);

    if (istVorschau) {
        return <StartbildVorschauPage />;
    }

    return (
        <ProjectProvider>
            <BadgeProvider>
                <Router basename="/">
                    <DirtyProvider>
                        <div>
                            <TabBar />
                            <Routes>
                                <Route path="/" element={<MainPage />} />
                                <Route path="/configuration" element={<ConfigurationTabs />} />
                                <Route path="/task-management" element={<TaskManagement />} />
                                <Route path="/internal-orders" element={<InternalOrders />} />
                                <Route path="/open-internal-orders" element={<OpenInternalOrders />} />
                                <Route path="/system-release" element={<SystemRelease />} />
                                <Route path="/tfHour-release" element={<TFHourRelease />} />
                                <Route path="/ai-chatbot" element={<AiChatbot />} />
                                <Route path="/systemplan-pdf-check" element={<SystemPlanPdfCheck />} />
                            </Routes>
                        </div>
                    </DirtyProvider>
                </Router>
            </BadgeProvider>
            {startbild !== 'weg' && <StartbildNetzplan ausblenden={startbild === 'ausblenden'} />}
        </ProjectProvider>
    );
}

export default App;
